import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Box, Modal, Typography, TextField } from "@mui/material";
import DashboardColumns from "../Utils/DashboardColumns";
import { AddLicence } from "../../../../../services/api/fytnServices";
import dataGridStyles from "../../../gridStyle";
import { toast } from "react-toastify";
import ModernSearchBar from "./ModernSearchBar";

const ReusableDataGridDashboard = ({ rows, fetchAdminAllUsers }) => {
  const [rowData, setRowData] = useState([]);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [columnFilters, setColumnFilters] = useState({
    USER_NAME: "",
    USER_EMAIL: "",
    CONTACT_NO: "",
    TOTAL_LICENSES: "",
    REMAINING_LICENSES: "",
    STATUS: ""
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [license, setLicense] = useState("");

  useEffect(() => {
    setRowData(rows);
    setFilteredRowData(rows);
  }, [rows]);

  // Column filter function
  const handleColumnFilter = (column, value) => {
    const newFilters = { ...columnFilters, [column]: value };
    setColumnFilters(newFilters);
    
    // Apply all filters
    let filtered = rowData;
    
    Object.keys(newFilters).forEach(filterColumn => {
      const filterValue = newFilters[filterColumn];
      if (filterValue.trim()) {
        filtered = filtered.filter(user => {
          const userValue = user[filterColumn];
          if (userValue === null || userValue === undefined) return false;
          return userValue.toString().toLowerCase().includes(filterValue.toLowerCase());
        });
      }
    });
    
    setFilteredRowData(filtered);
  };

  console.log("ROWSSS", rowData);
  // Handle button click to open modal
  const handleAction = (row) => {
    setSelectedRow(row);
    setLicense("");
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedRow(null);
    setLicense("");
  };

  const handleSave = async () => {
    if (!selectedRow || !license.trim()) {
      console.warn("Missing user or license value");
      return;
    }

    const data = {
      USER_AUTH_ID: selectedRow.USER_AUTH_ID,
      licenses_to_add: Number(license.trim()),
    };

    try {
      const res = await AddLicence(data);
      console.log("License added successfully:", res);
      if (res?.status === 200) {
        toast.success(res?.data?.message || "License added successfully");
        handleClose();
        setLicense("");
        fetchAdminAllUsers();
      } else {
        toast.error(res?.data?.message || "Failed to add license");
      }
    } catch (err) {
      console.error("Failed to add license:", err);
    }
  };

  const columns = DashboardColumns(handleAction, handleColumnFilter, columnFilters);

  return (
    <>
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Box sx={{ minWidth: "800px", height:500 }}>
          <DataGrid
            rows={filteredRowData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row.USER_AUTH_ID}
            disableRowSelectionOnClick
            components={{
              NoRowsOverlay: () => (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1" color="textSecondary">
                    {filteredRowData.length === 0 && rowData.length > 0
                      ? "No users found matching your search."
                      : "No users available."}
                  </Typography>
                </Box>
              ),
            }}
            sx={dataGridStyles}
          />
        </Box>
      </Box>

      {/* Modal */}
      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Add License
          </Typography>

          {/* Disabled Name Field */}
          <TextField
            fullWidth
            label="User Name"
            value={selectedRow?.USER_NAME || ""}
            margin="normal"
            disabled
          />

          {/* Editable License Field */}
          <TextField
            fullWidth
            label="Add License"
            value={license}
            onChange={(e) => setLicense(e.target.value)}
            margin="normal"
          />

          {/* Action Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={handleClose} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ReusableDataGridDashboard;
